

export const admin = {
  namespaced: true,
  state: {
    parameterOverviewSearch: null,
    processAnswerOverviewSearch: null,
    processBaseOverviewSearch: null,
    processStepOverviewSearch: null,
    workerRoleOverviewSearch: null,
    qrCodeOverviewSearch: null,
    facilityTypesOverviewSearch: null,
    documentationRuleOverviewSearch: null
  }, mutations: {
    storeParameterOverviewSearch(state, search) {
      state.parameterOverviewSearch = search;
    },
    storeProcessAnswerOverviewSearch(state, search) {
      state.processAnswerOverviewSearch = search;
    },
    storeProcessBaseOverviewSearch(state, search) {
      state.processBaseOverviewSearch = search;
    },
    storeProcessStepOverviewSearch(state, search) {
      state.processStepOverviewSearch = search;
    },
    storeWorkerRoleOverviewSearch(state, search) {
      state.workerRoleOverviewSearch = search;
    },
    storeQRCodeOverviewSearch(state, search) {
      state.qrCodeOverviewSearch = search;
    },
    storeFacilityTypesOverviewSearch(state, search) {
      state.facilityTypesOverviewSearch = search;
    },
    storeDocumentationRuleOverviewSearch(state, search) {
      state.documentationRuleOverviewSearch = search;
    }
  }
}
